module.exports = __webpack_public_path__ + "img/product.79ed0f2d.png";